export default "__VITE_ASSET__DFGN8Le9__"